import type { Vertex } from '@phi/jcore';
import { utility } from '@phi/components';
import { from_3d_coordinates_to_2d_screen_coordinates } from '@frontend/geometry_and_math';
import { enable_force_refresh } from '@frontend/state/force-refresh';
import { from_normalized_to_actual_screen_coordinates, get_display_unit_from_unitless_value } from '@frontend/utility';
import { Vector2 } from 'three';
import { PropType, defineComponent, h } from 'vue';
import app from '@frontend/application-container';
import { px } from '@phi/util/css';
import { from } from '@phi/newtype';
import { Text } from '@components/text';

export const VertexComponent = defineComponent({
    render() {
        return h(Text, {
            wrap: false,
            key: from(this.vertex),
            as: 'div',
            class: [
                utility.absolute,
                utility.no_interact,
            ],
            style: {
                left: px(this.coordinates.x),
                top: px(this.coordinates.y),
            },
        }, () => `(${this.x}, ${this.y}, ${this.z})`);
    },

    props: {
        vertex: {
            required: true,
            type: null as any as PropType<Vertex>,
        }
    },

    computed: {
        uid_vertex() {
            return uid_vertices.getItem(this.vertex);
        },

        position() {
            enable_force_refresh();
            return this.uid_vertex?.object3d?.position;
        },

        coordinates() {
            return this.position
                ? from_normalized_to_actual_screen_coordinates(from_3d_coordinates_to_2d_screen_coordinates(this.position))
                : new Vector2(-1, -1);
        },

        x() {
            return this.position
                ? get_display_unit_from_unitless_value(this.position.x).toFixed(app.settings.coordinate_decimals)
                : '';
        },

        y() {
            return this.position
                ? get_display_unit_from_unitless_value(this.position.y).toFixed(app.settings.coordinate_decimals)
                : '';
        },

        z() {
            return this.position
                ? get_display_unit_from_unitless_value(this.position.z).toFixed(app.settings.coordinate_decimals)
                : '';
        },
    }
});
